import React from 'react'
import { useState, useRef,useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Grid } from '@mui/material';
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Button from '@mui/material/Button';
import {FormHelperText} from '@mui/material';
import {
    ClassicEditor,
    Bold,
    Essentials,
    Heading,
    Indent,
    IndentBlock,
    Italic,
    Link,
    List,
    MediaEmbed,
    Paragraph,
    Table,
    Undo,
    ImageToolbar,
    Image,
    ImageUpload,
    ImageStyle,
    Base64UploadAdapter,
    FontFamily,
} from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';
import { useNavigate,NavLink } from 'react-router-dom';
import Cookies from "js-cookie";
// import MauvelousPrimaryButton from '../common/button/mauvelousPrimaryButton';
import { cssProperties } from '../../utils/commonCssProperties';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { Link as MuiLink, Typography } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import masterActions from '../../redux/master/actions'
import commonActions from '../../redux/common/actions';
import axios from 'axios';
import { API_URL } from '../../utils/constants';
import { useLocation } from 'react-router-dom';
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import CtkViewer from '../../common/CtkViewer';
import he from 'he'; 
import Metadata from '../../common/MetadataTable';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};



function getStyles(name, personName, theme) {
    return {
        fontWeight: personName.includes(name)
            ? theme.typography.fontWeightMedium
            : theme.typography.fontWeightRegular,
    };
}



const CreateTemplate = () => {
    const editorRef = useRef(null);
    const { state } = useLocation();
    const templateDetails = state?.templateDetails;
    const updatetemplateDetails=state?.updatetemplateDetails;
    const [triggerName, setTriggerName] = useState('');
    const [triggerCode, setTriggerCode] = useState('');
    const [checked, setChecked] = useState(true);
    const [eventType, setEventType] = useState('');
    const[templateNameState,setTemplateNameState]=useState('')
    const[email,setEmail]=useState('');
    const[subject,setSubject]=useState('')
    const[editor,setEditor]=useState('')
    const[templatebody,setTemplatebody]=useState('')
    const[templateid,settemplateid]=useState('')
    const[active,setActive]=useState('')
    const[goList,setGoList]=useState(false)
    const [metadata, setMetaData] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [showIframe, setShowIframe] = useState(false);
    const [errors, setErrors] = useState({
        triggerCode: false,
        eventtype:false,
        templateName: false,
        subject: false,
        editorContent: false,
        selectedCourses: false
      });
     const { templateList } = useSelector((state) => state.masterReducer);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const validateFields = () => {
        const newErr = {};
        if (!triggerName) newErr.triggerName = true;
        if (!eventType) newErr.eventtype = true;
        if (!templateNameState) newErr.templateName = true;
        if (!subject) newErr.subject = true;
        if (!editor || editor.replace(/<[^>]+>/g, '').trim() === '') newErr.editorContent = true;
       if (triggerName !== 'REG_PROFILE_SUBMITTED') {
    if (!personName || personName.length === 0) newErr.selectedCourses = true;
  }
        setErrors(newErr);
        return Object.keys(newErr).length === 0;
      };
      const validateUpdateFields = () => {
        const newErr = {};
        if (!triggerName) newErr.triggerName = true;
        if (!eventType) newErr.eventtype = true;
        if (!templateNameState) newErr.templateName = true;
        if (!subject) newErr.subject = true;
        if (!editor || editor.replace(/<[^>]+>/g, '').trim() === '') newErr.editorContent = true;
       if (triggerName !== 'Profile Submitted') {
    if (!personName || personName.length === 0) newErr.selectedCourses = true;
  }
        setErrors(newErr);
        return Object.keys(newErr).length === 0;
      };
    const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
    const { templateName,courseList,metaData } = useSelector((state) => state.masterReducer);
useEffect(()=>{
    dispatch({ type: masterActions.GET_TEMPLATE_LIST });
    dispatch({type:masterActions.GET_MASTER_TEMPLATE_NAME})
    dispatch({type:masterActions.GET_COURSE_LIST})
    dispatch({type:masterActions.GET_META_DATA})
},[])

useEffect(()=>{
    if(goList){
    navigate(`/${Cookies.get("mhet_mst_project")}/add-template?page=templatelist`);
}
},[goList])
useEffect(() => {
        if (Array.isArray(templateDetails) && templateDetails.length > 0) {
          const d = templateDetails[0];
          setTriggerName(d.triggername);
          setTriggerCode(d.triggercode);
          setEventType(d.eventtype);
          setTemplateNameState(d.templatename);
          setEmail(d.email);
          setSubject(d.subject);
          setPersonName(d.courses?.map(c => c.courseid) || []);
            // const body = templateDetails[0].templatebody;
            // if (editorRef.current) {
            //   editorRef.current.setData(body);
            // //   editorRef.current.enableReadOnlyMode('tpl');
            // }
            setEditor(d.templatebody);
          
        }
      
    
  }, [templateDetails]);
  useEffect(() => {
    if (Array.isArray(updatetemplateDetails) && updatetemplateDetails.length > 0) {
      const d = updatetemplateDetails[0];
      setTriggerName(d.triggername);
      setTriggerCode(d.triggercode);
      setEventType(d.eventtype);
      setTemplateNameState(d.templatename);
      setEmail(d.email);
      setSubject(d.subject);
      setTemplatebody(d.templatebody)
      settemplateid(d.templateid)
      setPersonName(d.courses?.map(c => c.courseid) || []);
      const body = updatetemplateDetails[0].templatebody;
            if (editorRef.current) {
              editorRef.current.value=body;
            }
        const encodedHtml = he.encode(d.templatebody); // ← encode HTML to show as plain text
      setEditor(encodedHtml);
      
      
    }
  

}, [updatetemplateDetails]);
    const handleCheckBoxChange = (event) => {
        setChecked(event.target.checked);
    };
    const handleChange = (event) => {
        const selectedCode = event.target.value;
        setTriggerName(selectedCode);       // ← Trigger code store karein
        setTriggerCode(
          templateName.all.find(t => t.triggercode === selectedCode)?.triggercode || ''
        );
        
        const found = templateName.all.find(t => t.triggercode === selectedCode);
        setEventType(found ? found.eventtype : '');
      };

    // const handleChange = (event) => {
    //     setTriggerName(event.target.value);
    // };

    const theme = useTheme();
    const [personName, setPersonName] = React.useState([]);

    const handleMultiSelectChange = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleBack = () => {
        navigate(`/${Cookies.get(
                "mhet_mst_project"
              )}/add-template?page=templatelist`)
    }
  const resetForm=()=>{
    if (editorRef.current?.editor) {
    editorRef.current.editor.setData(""); // ✅ Clear editor content
  }
    setTriggerName('');
    setTriggerCode('');
    setEventType('');
    setTemplateNameState('')
    setEmail('');
    setSubject('')

  }
  let userName = '';
  if (backofficeTokenDetails && backofficeTokenDetails?.name) {
      const shortendName = backofficeTokenDetails?.name?.trim()?.split(' ');
      if (shortendName?.length > 0) {
          userName = shortendName[0];
      }
  }
  const generatetemplateid = (templatename = "TEMPLATE") => {
    const sanitized = templatename.toUpperCase().replace(/\s+/g, "_");
    const randomSuffix = Math.random().toString(36).substring(2, 6).toUpperCase(); // 4-character random
    return `${sanitized}_${randomSuffix}`;
  };
   function decodeAndCleanHTML(encodedHtml) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = encodedHtml;
    let decodedHtml = textarea.value;

    decodedHtml = decodedHtml.replace(
    /<img\s+src="(?:<a\s+href="([^"]+)">[^<]*<\/a>)"([^>]*)>/g,
    '<img src="$1"$2>'
  );

  // Step 3: Remove <a> tags completely if they wrap <img> or elsewhere
  decodedHtml = decodedHtml.replace(/<a[^>]*>/g, '').replace(/<\/a>/g, '');

  // Step 4: Replace escaped quotes if needed (optional if from backend)
  decodedHtml = decodedHtml.replace(/\\"/g, '"'); return decodedHtml;
  }
    const handleSubmit=async()=>{
        if (!validateFields()) return;
        const exists = templateList.all.some(
            tpl => tpl.templatename.toLowerCase() === templateNameState.toLowerCase()
          );
          if(exists){
            dispatch({
                type: commonActions.SET_ALERT,
                payload: {
                  status: "failed",
                  show: true,
                  message:
                    "Template Name Already Exist.",
                },
              });
              setTimeout(()=>{
                dispatch({
                    type: commonActions.SET_ALERT,
                    payload: { status: null, show: false, message: null },
              })
              },[2000])
            
            return;
          }
        dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
        try{
            // const editor = editorRef.current.editor;
            // const htmlData = editor.getData();
          let data = {
             templatename: templateNameState,
            triggercode: triggerCode,
            email: email,
            subject: subject,
            templatebody: decodeAndCleanHTML(editor),
            courseselected: triggerName === 'REG_PROFILE_SUBMITTED' ? [] : personName,
            isactive:true,
            createdby:userName
              };
              const response = await axios.post(
                `${API_URL}/backoffice/email-template/add`,
                data
              );
              if (response.data.statusCode === 200) {
                setGoList(true);
                 dispatch({ type: masterActions.GET_TEMPLATE_LIST });
                resetForm?.();
               
                
                
              } else {
                console.warn('API error:', response.data.message);
              }
             }
             catch(err){
              const message = err.response?.data?.message || err.message || "Something went wrong. Please try again.";
              console.log(err.response?.data?.message , err.message,"catch error")
              dispatch({  type: commonActions.SET_ALERT,
                  payload:{
                      status:  "failed" ,
                      show: true,
                      message: message , 
                  }
                });
                setTimeout(()=>{
                  dispatch({  type: commonActions.SET_ALERT,
                      payload:{
                          status: null ,
                          show: false,
                          message: null, 
                      }
                    });
                },[2000])
                   
                console.error('Submit failed:', err);

             }
             dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
    }
    
    const cleanedHTML = (rawHTML) => {
  return rawHTML
    .replace(/<p[^>]*>/g, '')   // Remove <p> tags
    .replace(/<\/p>/g, '')      // Remove </p> tags
    .replace(/&nbsp;/g, ' ')    // Replace non-breaking spaces
    .replace(/\s+/g, ' ')       // Remove extra spaces
    .trim();                    // Remove leading/trailing spaces
};
    const handleupdate=async()=>{
      
        if (!validateUpdateFields()) return;
        dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
        try{
        
          let data = {
                 templateid: templateid,
             templatename: templateNameState,
            triggercode: triggerCode,
            email: email,
            subject: subject,
            templatebody:  he.decode(editor),
            courseselected: triggerName =='Profile Submitted' ? [] : personName,
            isactive:true,
            updatedby:userName
              };
              const response = await axios.put(
                `${API_URL}/backoffice/email-template/update`,
                data
              );
              if (response.data.statusCode === 200) {
                setGoList(true);
                 dispatch({ type: masterActions.GET_TEMPLATE_LIST });
                resetForm?.();
               
                
              } else {
                console.warn('API error:', response.data.message);
              }
             }
             catch(err){
              const message = err.response?.data?.message || err.message || "Something went wrong. Please try again.";
              console.log(err.response?.data?.message , err.message,"catch error") 
              dispatch({  type: commonActions.SET_ALERT,
                    payload:{
                        status:  "failed" ,
                        show: true,
                        message: message , 
                    }
                  });
                  setTimeout(()=>{
                    dispatch({  type: commonActions.SET_ALERT,
                        payload:{
                            status: null ,
                            show: false,
                            message: null, 
                        }
                      });
                  },[2000])
                console.error('Submit failed:', err);

             }
             dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
    }
    
    
    return (
        <>
      
            


                {/* Create Template code below */}

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column",backgroundColor:"white", paddingBottom:"20px" }}>
                    <Grid
                        container
                        spacing={2}
                        style={{ width: "70%", marginTop: ".5rem" }}
                    >
                        {/* First element: selects */}
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth size="small" style={{backgroundColor:"#fff"}}  error={errors.triggerName}>
                                <InputLabel id="trigger-label">Trigger Name*</InputLabel>
                                <Select
                                    labelId="trigger-label"
                                    id="trigger-select"
                                    value={templateDetails || updatetemplateDetails ? triggerCode : triggerName}
                                    label="Trigger Name*"
                                    onChange={handleChange}
                                    disabled={!!templateDetails || !!updatetemplateDetails}
                                >
                                  {templateName.all.map((temp) => (
  <MenuItem key={temp.triggercode} value={temp.triggercode}>
    {temp.triggername}
  </MenuItem>
))}
                                   
                                </Select>
                                {errors.triggerName && <FormHelperText>Please select trigger</FormHelperText>}
                            </FormControl>
                        </Grid>

                        {/* Second element: text field */}
                        <Grid item xs={12} md={6}>
                            <TextField
                            style={{backgroundColor:"#fff"}}
                                fullWidth
                                id="outlined-basic"
                                label="Event Type*"
                                variant="outlined"
                                size="small"
                                value={eventType}
                                InputProps={{ readOnly: true }}
                                disabled={!!templateDetails || updatetemplateDetails}
                                error={errors.eventtype}

                                helperText={errors.eventtype ? "Event Type is Required" : ""}
                            />
                        </Grid>
                    </Grid>

                    {/* Template Name grid */}
                    <Grid
                        container
                        spacing={2}
                        style={{ width: "70%", marginTop: 5 }}
                    >
                        <Grid item xs={12} md={12}>
                            <TextField
                            style={{backgroundColor:"#fff"}}
                                fullWidth
                                id="outlined-basic"
                                label="Template Name*"
                                variant="outlined"
                                size="small"
                                value={templateNameState}
                                onChange={(e)=>{
                                    setTemplateNameState(e.target.value)
                                }}
                                error={errors.templateName}
                                helperText={errors.templateName ? "Template Name is Required" : ""}
                                disabled={!!templateDetails || updatetemplateDetails}
                            />
                        </Grid>
                    </Grid>


                    {/* Email Grid */}
                    <Grid
                        container
                        spacing={2}
                        style={{ width: "70%", marginTop: 5 }}
                    >
                        <Grid item xs={12} md={12}>
                            {/* <FormControlLabel control={<Checkbox defaultChecked />} label="(Optional)" /> */}
                            <TextField
                            style={{backgroundColor:"#fff"}}
                                fullWidth
                                id="outlined-basic"
                                label= "Email"
                                variant="outlined"
                                size="small"
                                value={email}
                                onChange={(e)=>{
                                    setEmail(e.target.value)
                                }}
                                disabled={!!templateDetails}
                            />
                        </Grid>
                    </Grid>

                    {/* Subject Grid */}
                    <Grid
                        container
                        spacing={2}
                        style={{ width: "70%", marginTop: 5 }}
                    >
                        <Grid item xs={12} md={12}>
                            <TextField
                            style={{backgroundColor:"#fff"}}
                                fullWidth
                                id="outlined-basic"
                                label="Subject*"
                                variant="outlined"
                                size="small"
                                value={subject}
                                onChange={(e)=>{
                                    setSubject(e.target.value)
                                }}
                                error={errors.subject}
                                helperText={errors.subject ? "Subject is Required" : ""}
                                disabled={!!templateDetails}
                            />
                        </Grid>
                    </Grid>
<div style={{
    width:"70%",display:"flex",alignItems:"center",justifyContent:"flex-end",marginTop:"10px"
}}>
     <MauvelousPrimaryButton
              title="View Meta Data"
              handleClick={() => {
                setMetaData(true);
                setIsDialogOpen(true);
                setShowIframe(false);
              }}
              style={{
                display:"flex",alignItems:"center",justifyContent:"flex-end" 
              }}
            />
</div>
                    {/* Body Grid */}
                  {templateDetails && (
  <div
    style={{
      width: '68.5%',
      minHeight: '200px',
      margin: '10px',
      padding: '8px',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #ccc',
      borderRadius: '4px',
      backgroundColor: '#f9f9f9',
      overflowY: 'auto',
    }}
  >
    <CtkViewer content={editor} />
  </div>
)}
{updatetemplateDetails && (
  <Grid
                        container
                        spacing={2}
                        style={{ width: "70%", marginTop: 1 }}
                    >
                        <Grid item xs={12} md={12}>
   <CKEditor
   data={editor}
        editor={ClassicEditor}
         config={{  toolbar: [
                                        'undo', 'redo', '|',
                                        'heading', 'fontFamily', '|', 'bold', 'italic', '|',
                                        'link', 'imageUpload', 'insertTable', 'imageTextAlternative', '|',
                                        'bulletedList', 'numberedList', 'indent', 'outdent'
                                    ],
                                    plugins: [
                                        Bold,
                                        Essentials,
                                        Heading,
                                        Indent,
                                        IndentBlock,
                                        Italic,
                                        Link,
                                        List,
                                        Paragraph,
                                        Table,
                                        Undo,
                                        Image,
                                        ImageUpload,
                                        ImageToolbar,
                                        ImageStyle,
                                        FontFamily,
                                    ],
                                    initialData: editor ? editor :'',
                                    image: {
                                        toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side'],
                                        styles: [
                                            'full',
                                            'side'
                                        ],
                                        resizeUnit: 'px'
                                    },
                                    extraPlugins: [Base64UploadAdapter],

                                }}
        onReady={(editor) => {
          editor.editing.view.change(writer => {
            writer.setStyle("white-space", "pre-wrap", editor.editing.view.document.getRoot());
            writer.setStyle("font-family", "monospace", editor.editing.view.document.getRoot());
          });
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          setEditor(data);
        }}
      />
      </Grid>
      </Grid>

)}
                  {!templateDetails && !updatetemplateDetails && (
                    <Grid
                        container
                        spacing={2}
                        style={{ width: "70%", marginTop: 1 }}
                    >
                        <Grid item xs={12} md={12}>
                            {/* <Editor value={text} onTextChange={(e) => setText(e.htmlValue)} style={{ height: '320px' }} /> */}
                            
                            <CKEditor

//  data={editor}

                                editor={ClassicEditor}
                                config={{  toolbar: [
                                        'undo', 'redo', '|',
                                        'heading', 'fontFamily', '|', 'bold', 'italic', '|',
                                        'link', 'imageUpload', 'insertTable', 'imageTextAlternative', '|',
                                        'bulletedList', 'numberedList', 'indent', 'outdent'
                                    ],
                                    plugins: [
                                        Bold,
                                        Essentials,
                                        Heading,
                                        Indent,
                                        IndentBlock,
                                        Italic,
                                        Link,
                                        List,
                                        Paragraph,
                                        Table,
                                        Undo,
                                        Image,
                                        ImageUpload,
                                        ImageToolbar,
                                        ImageStyle,
                                        FontFamily,
                                    ],
                                    initialData: editor ? editor :'',
                                    image: {
                                        toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side'],
                                        styles: [
                                            'full',
                                            'side'
                                        ],
                                        resizeUnit: 'px'
                                    },
                                    extraPlugins: [Base64UploadAdapter],

                                }}
                                
                                onReady={(editorInstance) => {
     editorRef.current = editorInstance;
     if (editor) {
         editorInstance.setData(editor);  // Set initial content once
     }
 }}
 onChange={(event, editorInstance) => {
     setEditor(cleanedHTML(editorInstance.getData()));
 }}

                            />
                            {errors.editorContent && (
      <Typography color="error" variant="caption" sx={{ ml: 1 }}>
        Body is required
      </Typography>
    )}

                        </Grid>
                    </Grid>
                  ) }  

                    {/* Multi Select Fields */}
                    <Grid
                        container
                        spacing={2}
                        style={{ width: "70%", marginTop: 5 }}
                    >
                   {triggerName !=='Profile Submitted' && (
<Grid item xs={12} md={12}>
                        <FormControl sx={{  minWidth: "100%" }} error={triggerName === 'REG_PROFILE_SUBMITTED' ? "" : errors.selectedCourses}>
                                <InputLabel size='small' id="demo-multiple-chip-label">Select Courses*</InputLabel>
                                <Select
                                 style={{backgroundColor:"#fff"}}
                                size='small'
                                    labelId="demo-multiple-chip-label"
                                    id="demo-multiple-chip"
                                    multiple
                                    value={personName}
                                    onChange={handleMultiSelectChange}
                                    input={<OutlinedInput id="select-multiple-chip" label="Select Courses*" />}
                                    renderValue={(selectedIds) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                          {selectedIds.map(id => {
                                            const course = courseList.all.find(c => c.courseid === id);
                                            return <Chip key={id} label={course?.coursename || id} />;
                                          })}
                                        </Box>
                                      )}
                                    MenuProps={MenuProps}
                                    disabled={!!templateDetails || triggerName === 'REG_PROFILE_SUBMITTED'}
                                >
                                    {courseList.all.map((name) => (
                                        <MenuItem
                                            key={name.courseid}
                                            value={name.courseid}
                                            style={getStyles(name, personName, theme)}
                                        >
                                            {name.coursename}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {triggerName !== 'REG_PROFILE_SUBMITTED' && errors.selectedCourses && (
    <FormHelperText>Select at least one course</FormHelperText>
  )}
                            </FormControl>

                        </Grid>
                   )}     
                    </Grid>


                    {/* Action Buttons */}
                    <div style={{display:"flex", width:"70%", justifyContent:"center", marginTop:"1rem"}}>
                    <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <Button style={{marginRight:10}} variant='outlined' size='small' onClick={handleBack}>
                            Back
                        </Button>

                       {!templateDetails && !updatetemplateDetails && (
                        <Button variant='contained' style={{marginLeft:5, backgroundColor:"#e697ab", color:cssProperties?.surface?.primary}} size='small' onClick={handleSubmit}>
                            Create
                        </Button>
                       )} 
                       {updatetemplateDetails && (
                        <Button variant='contained' style={{marginLeft:5, backgroundColor:"#e697ab", color:cssProperties?.surface?.primary}} size='small' onClick={handleupdate}>
                            Edit
                        </Button>
                       )} 
                                    {/* <MauvelousPrimaryButton
                                      title={"Create"}
                                    //   handleClick={() => null }
                                    /> */}
                    </div>
                    </div>

                </div>
                {isDialogOpen && (
                          <Metadata isDialogOpen={isDialogOpen} 
                          setIsDialogOpen={setIsDialogOpen}
                          metaData={metaData}
                          metadata={metadata}
                          setMetaData={setMetaData}/>
                        )}

       
        </>
    )
}

export default CreateTemplate
